export default {"src":"/_next/static/media/404.624cc04e.svg","height":453,"width":556,"blurWidth":0,"blurHeight":0};